const icons = {
  add: "icon_add",
  edit: "icon_edit",
  del: "icon_del",
  view: "icon_view", //查看
  addMenu: "icon_add_menu", //新增菜单
  resetPwd: "icon_reset_pwd", //重置密码
  addChild: "icon_add_child", //新增子节点
  assign: "icon_assign_roles", //分配角色
  data_management: "icon_data", //数据管理
  disabled: "icon_disabled", //停用
  enable: "icon_enable", //启用
  download: "icon_download",
  exit: "icon_exit", //强制退出
  offline: "icon_offline", //下线
  online: "icon_online", //上线
  preview: "icon_preview", //预览
  user_management: "icon_users", //用户管理
  version: "icon_versions", //版本管理
  import: "icon_import", //导入
  export: "icon_export",
  sync: "icon_sync", //同步
  syncLog: "icon_sync_log", //同步日志
  upload: "icon_upload",
  role: "icon_role", //分配角色
  send: "icon_send", //发送
  send_log: "icon_send_log", //发送日志
  permissions: "icon_permissions", //权限
  basic_info: "icon_basic_info", //基本信息
  last: "icon_last", // 撤销
  next: "icon_next", // 还原
  enlarge: "icon_enlarge", // 放大
  reduce: "icon_reduce", // 缩小
  reset: "icon_reset", // 重置
  check_flow: "icon_check_flow", // 流程检查
  indicator_version: "icon_indicator_version", //指标版本
  indicator: "icon_indicator", //指标
  indicator_library: "icon_indicator_library", //指标库
  set_default: "icon_set_default", //设置默认
  resource_version: "icon_resource_version", //资源版本
  copy: "icon_copy", //复制
  visual: "icon-visual", //可视化配置
  import_indicator: "icon_import_indicator", //引入指标
  node_dispose: "icon_node_dispose", // 流程节点配置
  move_up: "icon_move_up", // 上移
  move_down: "icon_move_down", // 下移
  sort: "icon_sort", // 排序
  user_org: "icon_user_org", // 用户分配组织机构
  origin_password: "icon_origin_password", // 原始密码
  search: "icon_search",
  search_reset: "icon_search_reset",
  transfer_data: "icon_transfer_data",
  setting: "icon_setting",
};
export default icons;
